module.exports = __webpack_public_path__ + "img/Man_made_material_1200x800.810f8d5f.png";